var FormulaError = require('../error');

var _require = require('../helpers'),
    FormulaHelpers = _require.FormulaHelpers,
    Types = _require.Types,
    Factorials = _require.Factorials;

var H = FormulaHelpers;
var LogicalFunctions = {
  AND: function AND() {
    for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }

    var result = H.accept(params.shift(), Types.BOOLEAN);
    params.forEach(function (param) {
      result = result && H.accept(param, Types.BOOLEAN);
    });
    return result;
  },
  FALSE: function FALSE() {
    return false;
  },
  // Special
  IF: function IF(context, logicalTest, valueIfTrue, valueIfFalse) {
    logicalTest = H.accept(logicalTest, Types.BOOLEAN);
    valueIfTrue = H.accept(valueIfTrue); // do not parse type

    valueIfFalse = H.accept(valueIfFalse, null, false); // do not parse type

    return logicalTest ? valueIfTrue : valueIfFalse;
  },
  IFERROR: function IFERROR(value, valueIfError) {
    return value.value instanceof FormulaError ? H.accept(valueIfError) : H.accept(value);
  },
  IFNA: function IFNA(value, valueIfNa) {
    return value.value === FormulaError.NA ? H.accept(valueIfNa) : H.accept(value);
  },
  IFS: function IFS() {},
  NOT: function NOT(logical) {
    logical = H.accept(logical, Types.BOOLEAN);
    return !logical;
  },
  OR: function OR() {
    for (var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      params[_key2] = arguments[_key2];
    }

    var result = H.accept(params.shift(), Types.BOOLEAN);
    params.forEach(function (param) {
      result = result || H.accept(param, Types.BOOLEAN);
    });
    return result;
  },
  SWITCH: function SWITCH() {},
  TRUE: function TRUE() {
    return true;
  },
  XOR: function XOR() {}
};
module.exports = LogicalFunctions;